import { render } from "./RowspanAndColspan.vue?vue&type=template&id=f5c00e8e&ts=true"
import script from "./RowspanAndColspan.vue?vue&type=script&lang=ts"
export * from "./RowspanAndColspan.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__